import React from "react";
import { Navigate } from "react-router-dom";

export default function RoleGuard({ roles, children }) {
  const raw = localStorage.getItem("kskfield_user");
  if (!raw) return <Navigate to="/login" replace />;
  let user;
  try { user = JSON.parse(raw); } catch {}
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
